import React from 'react';
import { QuoteCardProps } from './QuoteCard.types';
import {
  CardTextWrapper,
  QuoteCardWrapper,
  LeftQuotationWrapper,
  RightQuotationWrapper
} from './QuoteCard.styles';

const QuoteCard = ({ cardText }: QuoteCardProps) => {
  return (
    <QuoteCardWrapper>
      <LeftQuotationWrapper>“</LeftQuotationWrapper>
      <CardTextWrapper>{cardText}</CardTextWrapper>
      <RightQuotationWrapper>”</RightQuotationWrapper>
    </QuoteCardWrapper>
  );
};

export default QuoteCard;
